"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER = void 0;
class USER {
}
exports.USER = USER;
/** @USERNAME */
USER.USERNAME_MIN_LENGTH = 6;
USER.USERNAME_MAX_LENGTH = 36;
// 공백
USER.USERNAME_EMPTY_SPACE_MIN_COUNT = -1;
USER.USERNAME_EMPTY_SPACE_MAX_COUNT = 0;
// 숫자
USER.USERNAME_NUMBER_MIN_COUNT = -1;
USER.USERNAME_NUMBER_MAX_COUNT = -1;
// 알파벳
USER.USERNAME_ALPHABET_MIN_COUNT = 1;
USER.USERNAME_ALPHABET_MAX_COUNT = -1;
// 알파벳(소문자)
USER.USERNAME_ALPHABET_LOWERCASE_MIN_COUNT = -1;
USER.USERNAME_ALPHABET_LOWERCASE_MAX_COUNT = -1;
// 알파벳(대문자)
USER.USERNAME_ALPHABET_UPPERCASE_MIN_COUNT = -1;
USER.USERNAME_ALPHABET_UPPERCASE_MAX_COUNT = -1;
// 특수문자
USER.USERNAME_SPECIAL_CHARACTER_MIN_COUNT = 0;
USER.USERNAME_SPECIAL_CHARACTER_MAX_COUNT = 0;
// 숫자로 시작해야하는가
USER.USERNAME_STARTS_WITH_NUMBER = false;
// 알파벳으로 시작해야하는가
USER.USERNAME_STARTS_WITH_ALPHABET = false;
// 특수문자로 시작해야하는가
USER.USERNAME_STARTS_WITH_SPECIAL_CHARACTER = false;
/** @PASSWORD */
USER.PASSWORD_MIN_LENGTH = 9;
USER.PASSWORD_MAX_LENGTH = 100;
// 공백
USER.PASSWORD_EMPTY_SPACE_MIN_COUNT = -1;
USER.PASSWORD_EMPTY_SPACE_MAX_COUNT = 0;
// 숫자
USER.PASSWORD_NUMBER_MIN_COUNT = 1;
USER.PASSWORD_NUMBER_MAX_COUNT = -1;
// 알파벳
USER.PASSWORD_ALPHABET_MIN_COUNT = 1;
USER.PASSWORD_ALPHABET_MAX_COUNT = -1;
// 알파벳(소문자)
USER.PASSWORD_ALPHABET_LOWERCASE_MIN_COUNT = 1;
USER.PASSWORD_ALPHABET_LOWERCASE_MAX_COUNT = -1;
// 알파벳(대문자)
USER.PASSWORD_ALPHABET_UPPERCASE_MIN_COUNT = 1;
USER.PASSWORD_ALPHABET_UPPERCASE_MAX_COUNT = -1;
// 특수문자
USER.PASSWORD_SPECIAL_CHARACTER_MIN_COUNT = 1;
USER.PASSWORD_SPECIAL_CHARACTER_MAX_COUNT = -1;
// 숫자로 시작해야하는가
USER.PASSWORD_STARTS_WITH_NUMBER = false;
// 알파벳으로 시작해야하는가
USER.PASSWORD_STARTS_WITH_ALPHABET = false;
// 특수문자로 시작해야하는가
USER.PASSWORD_STARTS_WITH_SPECIAL_CHARACTER = false;
// bcrypt hash string length
USER.PASSWORD_HASH_LENGTH = 60;
// bcrypt salt round
USER.PASSWORD_BCRYPT_SALT_ROUND = 14;
// Validation
USER.REGEX_SPECIAL_CHARACTER = /[~`!@#$%^&*()\-+={[}\]|\\:;"'<,>.?/]/g;
(function (USER) {
    let TYPE;
    (function (TYPE) {
        TYPE["SUPER_USER"] = "SUPER_USER";
        TYPE["ACCOUNT_HOLDER"] = "ACCOUNT_HOLDER";
        TYPE["NORMAL"] = "NORMAL";
    })(TYPE = USER.TYPE || (USER.TYPE = {}));
    (function (TYPE) {
        function toString(type) {
            switch (type) {
                case TYPE.SUPER_USER:
                    return '최고관리자';
                case TYPE.ACCOUNT_HOLDER:
                    return '계정 소유자';
                case TYPE.NORMAL:
                    return '일반 사용자';
            }
        }
        TYPE.toString = toString;
    })(TYPE = USER.TYPE || (USER.TYPE = {}));
})(USER = exports.USER || (exports.USER = {}));
